export default () => ({
  items: [],
  totals: {},
  mediacontent: {},
  sites: [],
  count: 0,
});
